import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { intrinsicComponent } from './utils/functions';
export var FlipX = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0625 1.93758C24.0625 1.22909 23.5858 0.609274 22.901 0.427427C22.2163 0.245581 21.4949 0.547225 21.1434 1.16237L1.14337 39.2874C0.867028 39.771 0.869012 40.3651 1.14858 40.8468C1.42814 41.3286 1.94302 41.6251 2.5 41.6251H22.5C23.3629 41.6251 24.0625 40.9255 24.0625 40.0626V1.93758ZM20.9375 38.5001H5.19247L20.9375 7.82128V38.5001Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8566 1.16237C28.5051 0.547225 27.7837 0.245581 27.099 0.427428C26.4142 0.609274 25.9375 1.22909 25.9375 1.93758V4.12508H26.9504L27.3934 4.9003L28.75 4.12508H29.0625V3.94651L30.1066 3.34986L28.8566 1.16237Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1066 12.0999L32.6066 7.72486L29.8934 9.2753L32.3934 13.6503L35.1066 12.0999Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 8.50008V12.8751H29.0625V8.50008H25.9375Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1066 23.9749L37.6066 19.5999L34.8934 21.1503L37.3934 25.5253L40.1066 23.9749Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 20.3751V24.7501H29.0625V20.3751H25.9375Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1066 32.7249L42.6066 28.3499L39.8934 29.9003L42.3934 34.2753L45.1066 32.7249Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 29.1251V33.5001H29.0625V29.1251H25.9375Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8566 39.2874L47.6066 37.0999L45.1562 38.5001H45V38.5894L44.8934 38.6503L45 38.8369V41.6251H47.5C48.057 41.6251 48.5719 41.3286 48.8514 40.8468C49.131 40.3651 49.133 39.771 48.8566 39.2874Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 37.8751V40.0626C25.9375 40.9255 26.6371 41.6251 27.5 41.6251H30V38.5001H29.0625V37.8751H25.9375Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 41.6251H40V38.5001H35V41.6251Z",
    fill: color
  }));
});
export default FlipX;